import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    var swiperBeneficios = new Swiper('.slider-beneficios', {
        slidesPerView: 1,
        spaceBetween: 40,
        speed: 500,
        autoplay: {
            delay: 3000,
        },
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoHeight: true,
        breakpointsInverse: true,
        breakpoints: {
            // when window width is >= 599px
            599: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            // when window width is >= 900px
            900: {
                slidesPerView: 3,
                spaceBetween: 20
            },
        }
    });

    var swiperMain = new Swiper('.main-slider', {
        slidesPerView: 1,
        speed: 600,
        // autoplay: {
        //     delay: 4000,
        // },
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        autoHeight: true,
    });

    const swiperMainSlides = document.querySelectorAll(`.main-slider .swiper-slide`);

    if (swiperMainSlides.length === 1){
        swiperMain.destroy();
    }
};
